/* istanbul ignore file - better tested visually */

import { DependencyList, useEffect } from 'react';

export const useAnimationFrameEffect = (callback: () => void, deps?: DependencyList) => {
  useEffect(() => {
    requestAnimationFrame(callback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
